export default "https://cdn-static.gokick.com/assets/0205635f2685a00e1fdcb9112c4ac213a84703ca/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";